module.exports = "/images/inventory_white.svg?543f86f13e1d0e85e56abc1b8244b9bc";